import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignature } from '@fortawesome/pro-light-svg-icons/faSignature';
import LinkButton from '../common/Buttons/LinkButton';

const ChangeMfaArea = (props) => {
  const { mfaCode, mfaImage, onChange, onConfirm, mfaEnabled, onCancel, t } = props;
  const changeDataFromEvent = (event) => {
    onChange(event.target.value);
  };

  const isValidData = () => {
    const validMfa = !mfaCode || mfaCode.length === 6;
    return validMfa;
  };

  return (
    <div className="settings-list editing">
      <h1>
        <span>
          <FontAwesomeIcon icon={faSignature} />
          &nbsp; {mfaEnabled ? t('labelDisableMfa') : t('labelEnableMfa')}
        </span>
        <LinkButton className="edit-button" onClick={onCancel}>
          {t('labelGoBack')}
        </LinkButton>
      </h1>
      {!mfaEnabled ? (
        <div className="settings-list__item">
          <span className="label">{t('descriptionEnableMfa')}</span>
        </div>
      ) : null}
      <div className="settings-list__item">
        <span className="label">{t('labelMfaCode')}</span>
        <span className="input">
          <input name="password" type="number" maxLength={6} max="6" className="form-control" value={mfaCode} autoComplete="off" onChange={changeDataFromEvent} />
        </span>
      </div>
      {!mfaEnabled ? (
        <div className="enable-mfa-area">
          <img src={mfaImage} alt="" />
        </div>
      ) : null}
      <div className="text-right">
        <button type="button" disabled={!isValidData()} className="btn btn-secondary" onClick={onConfirm}>
          {t('labelConfirm')}
        </button>
      </div>
    </div>
  );
};

export default ChangeMfaArea;
